import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

// 김포 풍무역 푸르지오 시티 Firebase 프로젝트 설정
const firebaseConfig = {
  apiKey: "AIzaSyCv7yb-46ErX0hq8VJ_9L534hM5JbvMOa8",
  authDomain: "purugiocity.firebaseapp.com",
  projectId: "purugiocity",
  storageBucket: "purugiocity.firebasestorage.app",
  messagingSenderId: "469352758079",
  appId: "1:469352758079:web:c18d5e3acb9234493f318a",
  measurementId: "G-ZTDM5GDN9H"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
